module.exports = __webpack_public_path__ + "static/media/recolte.01e0f32d.png";